angular.module('impactx.catalogruleresult').controller('CatalogRuleInvalidProductLabelsListCtrl',
    CatalogRuleInvalidProductLabelsListCtrl);

CatalogRuleInvalidProductLabelsListCtrl.$inject = ['$routeParams'];

function CatalogRuleInvalidProductLabelsListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruleinvalidproductlabelslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruleinvalidproductlabelslist',
        id: "catalogruleinvalidproductlabelslist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}